import React from "react";
import { FaUniversity, FaUserGraduate, FaCompass, FaPassport, FaGlobe, FaChalkboardTeacher, FaHandshake, FaMoneyCheckAlt } from "react-icons/fa";
import "./ServicePage.css";
import uni from '../Pages/images/uk.jpg'
import admins from '../Pages/images/couching/admis.avif'
import carrer from '../Pages/images/couching/carrer.jpg'
import visa from '../Pages/images/couching/visa.avif'
import dep from '../Pages/images/couching/dep.jpeg'
import traing from '../Pages/images/couching/lear.webp'
import scolor from '../Pages/images/couching/sc.avif'
import fin from '../Pages/images/couching/finance.jpeg'

const servicesData = [
  {
    icon: <FaUniversity />,
    title: "University Selection",
    text: "Guiding you to choose the best university that aligns with your career aspirations and financial plan.",
    imgUrl: uni,
  },
  {
    icon: <FaUserGraduate />,
    title: "Admission Guidance",
    text: "Helping you navigate the complex admission process, ensuring all your documents and timelines are perfectly managed.",
    imgUrl: admins,
  },
  {
    icon: <FaCompass />,
    title: "Career Guidance",
    text: "Providing one-on-one career counseling to help you discover your interests and achieve your goals.",
    imgUrl: carrer,
  },
  {
    icon: <FaPassport />,
    title: "Visa Preparation",
    text: "Assisting you with hassle-free visa documentation and mock visa interviews to boost your confidence.",
    imgUrl: visa,
  },
  {
    icon: <FaGlobe />,
    title: "Pre-departure Briefing",
    text: "Providing you essential tips on cultural adaptation, accommodation, and travel essentials before you leave.",
    imgUrl: dep,
  },
  {
    icon: <FaChalkboardTeacher />,
    title: "Language Training",
    text: "Offering IELTS, TOEFL, and GRE training from certified instructors to strengthen your application.",
    imgUrl: traing,
  },
  {
    icon: <FaHandshake />,
    title: "Scholarship Assistance",
    text: "Helping you identify and apply for scholarships and financial aid to reduce your study abroad expenses.",
    imgUrl: scolor,
  },
  {
    icon: <FaMoneyCheckAlt />,
    title: "Financial Guidance",
    text: "Connecting you with reliable financial institutions for student loans and forex services.",
    imgUrl: fin,
  },
];

const ServicePage = () => {
  return (
    <div className="service-page">
      <h1 className="page-title">Our Services</h1>
      <p className="page-subtitle">Empowering your global academic journey with trusted guidance and support.</p>
      <div className="services-container">
        {servicesData.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.imgUrl} alt={service.title} className="service-image" />
            <div className="service-content">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicePage;
